var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _vm.data.length > 0
    ? _c("div", { staticClass: "col-12" }, [
        _c("div", { staticClass: "single-crossselling__headline" }, [
          _vm._v(
            _vm._s(_vm.$translate("OD3dprimaV2::Template.crosssellerHeadline"))
          ),
        ]),
        _vm._v(" "),
        _c("div", { staticClass: "row" }, [
          _c("div", { staticClass: "col-12" }, [
            _c(
              "div",
              { staticClass: "single-crossselling" },
              [
                _vm._l(_vm.data, function (item) {
                  return _c(
                    "div",
                    {
                      staticClass: "single-crossselling__item",
                      attrs: {
                        "data-price": _vm.getPrice(
                          "prices.default.data.basePrice" + _vm.appendNet,
                          item.data
                        ),
                        "data-id": item.id,
                      },
                    },
                    [
                      _c("div", {
                        staticClass:
                          "single-crossselling__indicator single-crossselling__indicator--add",
                        attrs: {
                          "data-container": "body",
                          "data-html": "true",
                          "data-trigger": "hover",
                          "data-toggle": "popover",
                          "data-placement": "top",
                          "data-content": "Artikel zum Warenkorb hinzufügen",
                        },
                      }),
                      _vm._v(" "),
                      _c(
                        "div",
                        {
                          staticClass:
                            "single-crossselling__indicator single-crossselling__indicator--remove d-none",
                          attrs: {
                            "data-container": "body",
                            "data-html": "true",
                            "data-trigger": "hover",
                            "data-toggle": "popover",
                            "data-placement": "top",
                            "data-content": "Artikel vom Warenkorb entfernen",
                          },
                        },
                        [
                          _c("img", {
                            attrs: {
                              src: _vm.pluginPath + "/images/icon-check.svg",
                            },
                          }),
                        ]
                      ),
                      _vm._v(" "),
                      _c("div", { staticClass: "single-crossselling__image" }, [
                        _c("img", {
                          staticClass: "img-fluid",
                          attrs: {
                            src: item.data.images.all[0].urlMiddle,
                            alt: item.data.texts.name1,
                          },
                        }),
                      ]),
                      _vm._v(" "),
                      _c("div", { staticClass: "single-crossselling__name" }, [
                        _c(
                          "a",
                          {
                            attrs: {
                              href: _vm._f("itemURL")(item.data),
                              title: item.data.texts.name1,
                            },
                          },
                          [
                            _vm._v(
                              "\n                            " +
                                _vm._s(item.data.texts.name1) +
                                "\n                        "
                            ),
                          ]
                        ),
                      ]),
                      _vm._v(" "),
                      _c(
                        "div",
                        { staticClass: "single-crossselling__price" },
                        [
                          _vm._v(
                            "+ " +
                              _vm._s(
                                _vm._f("currency")(
                                  _vm.getPrice(
                                    "prices.default.data.basePrice" +
                                      _vm.appendNet,
                                    item.data
                                  )
                                )
                              ) +
                              "\n                        "
                          ),
                          item.data.prices.rrp &&
                          item.data.prices.rrp.price &&
                          item.data.prices.rrp.price.value >
                            item.data.prices.default.price.value
                            ? [
                                _c(
                                  "span",
                                  {
                                    staticClass:
                                      "single-crossselling__price-uvp",
                                  },
                                  [
                                    _c("del", [
                                      _vm._v(
                                        _vm._s(
                                          _vm._f("currency")(
                                            _vm.getPrice(
                                              "prices.rrp.data.basePrice" +
                                                _vm.appendNet,
                                              item.data
                                            )
                                          )
                                        )
                                      ),
                                    ]),
                                  ]
                                ),
                              ]
                            : _vm._e(),
                        ],
                        2
                      ),
                    ]
                  )
                }),
                _vm._v(" "),
                _vm.count > 4
                  ? [
                      _c(
                        "div",
                        { staticClass: "single-crossselling__show-more" },
                        [
                          _c(
                            "div",
                            { staticClass: "single-crossselling__indicator" },
                            [
                              _c("img", {
                                attrs: {
                                  src:
                                    _vm.pluginPath +
                                    "/images/icon-arrow-down.svg",
                                },
                              }),
                            ]
                          ),
                          _vm._v(" "),
                          _c("span", [
                            _vm._v(
                              _vm._s(
                                _vm.$translate(
                                  "OD3dprimaV2::Template.crosssellerMore"
                                )
                              )
                            ),
                          ]),
                        ]
                      ),
                      _vm._v(" "),
                      _c(
                        "div",
                        {
                          staticClass: "single-crossselling__show-less d-none",
                        },
                        [
                          _c(
                            "div",
                            { staticClass: "single-crossselling__indicator" },
                            [
                              _c("img", {
                                attrs: {
                                  src:
                                    _vm.pluginPath +
                                    "/images/icon-arrow-down.svg",
                                },
                              }),
                            ]
                          ),
                          _vm._v(" "),
                          _c("span", [
                            _vm._v(
                              _vm._s(
                                _vm.$translate(
                                  "OD3dprimaV2::Template.crosssellerLess"
                                )
                              )
                            ),
                          ]),
                        ]
                      ),
                    ]
                  : _vm._e(),
              ],
              2
            ),
          ]),
          _vm._v(" "),
          _c("div", { staticClass: "col-12" }, [
            _c("div", { staticClass: "single-crossselling__receiver" }, [
              _c("div", {
                staticClass: "single-crossselling__receiver-images",
              }),
              _vm._v(" "),
              _c(
                "div",
                { staticClass: "single-crossselling__receiver-total" },
                [
                  _c("span", [
                    _vm._v(
                      _vm._s(
                        _vm.$translate("OD3dprimaV2::Template.crosssellerTotal")
                      ) + " "
                    ),
                  ]),
                  _c("span", {
                    staticClass: "single-crossselling__receiver-total-price",
                  }),
                  _vm._v(" "),
                  _c(
                    "button",
                    {
                      staticClass:
                        "btn btn-primary single-crossselling__add-to-basket",
                      attrs: { disabled: "" },
                    },
                    [
                      _vm._v(
                        _vm._s(
                          _vm.$translate(
                            "OD3dprimaV2::Template.crosssellerAddToBasketButton"
                          )
                        ) + "\n                    "
                      ),
                    ]
                  ),
                  _vm._v(" "),
                  _c("input", {
                    attrs: {
                      type: "hidden",
                      value: "false",
                      id: "single-crossselling__add-add-items",
                    },
                  }),
                ]
              ),
            ]),
          ]),
        ]),
      ])
    : _vm._e()
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }